// extracted by mini-css-extract-plugin
module.exports = {"component":"background_3_6Ro","transitionEnter":"background_3vze1","transitionEnterActive":"background_1lJiW"};